import { render, staticRenderFns } from "./NhlTeamStack.vue?vue&type=template&id=0f95f28e&scoped=true"
import script from "./NhlTeamStack.vue?vue&type=script&lang=js"
export * from "./NhlTeamStack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f95f28e",
  null
  
)

export default component.exports